exports.allCursors = allCursors = [
  'pointer',
  'default',
  'move',
  'alias',
  'all-scroll',
  'auto',
  'cell',
  'context-menu',
  'col-resize',
  'copy',
  'crosshair',
  'e-resize',
  'ew-resize',
  'help',
  'n-resize',
  'ne-resize',
  'nesw-resize',
  'ns-resize',
  'nw-resize',
  'nwse-resize',
  'no-drop',
  'none',
  'not-allowed',
  'progress',
  'row-resize',
  's-resize',
  'se-resize',
  'sw-resize',
  'text',
  'vertical-text',
  'w-resize',
  'wait',
  'zoom-in',
  'zoom-out',
]



// WEBPACK FOOTER //
// ./src/cursors.coffee